import React from 'react';

import Spinner from 'components/shared/Spinner';

export type SpecialContentMenuItemData = {
  id: string | number;
  image: string;
  pendingImage?: boolean;
  label: React.ReactNode;
  handleSelectItem: (id: string | number) => void;
  selected?: boolean;
};

export type SpecialContentMenuItemProps = SpecialContentMenuItemData & {
  parent: string;
  handleCloseMenu: () => void;
};

function SpecialContentMenuItem({
  id,
  handleCloseMenu,
  parent,
  image,
  pendingImage = false,
  label,
  selected = false,
  handleSelectItem,
}: SpecialContentMenuItemProps) {
  function onSelectItem() {
    handleCloseMenu();
    handleSelectItem(id);
  }

  const labelId = `${parent}-label-${id}`;

  return (
    <li className={`special-content-menu-item ${selected ? 'selected' : ''}`}>
      <button
        aria-labelledby={labelId}
        onClick={onSelectItem}
        id={`special-content-menu-item-${id}`}
      >
        {pendingImage && <Spinner size="50" color="#252525" />}
        {!pendingImage && image && <img src={image} alt="" />}
      </button>
      <p id={labelId} className="item-label">
        {label}
      </p>
    </li>
  );
}

export default SpecialContentMenuItem;
